import {post, get, patch} from '@/lib/axios';

const company = {
  async get_company_by_id(id) {
    return get(`/company/${id}`);
  },
  async post_company_by_id(id, data) {
    return patch(`/company/${id}`, data);
  },
  async edit_company(id) {
    return patch(`/company/{id}`);
  },
  async get_companies(page_size, page_num, group, spec, llk, name, by, order) {
    return get(`/company`, {page_size, page_num, group, spec, llk, name, by, order});
  },
  async add_company(data) {
    return post(`/company`, data);
  },
  async get_companies_form() {
    return get(`/company/form`);
  },
  async get_companies_filters() {
    return get(`/company/filter`);
  },
  async company_activate(company_id) {
    return patch(`/company/${company_id}/activate`);
  },
  async company_decline(company_id) {
    return patch(`/company/{company_id}/decline`);
  },
  async company_requests(page_size, page_num, by, order) {
    return get(`/company/requests`, {page_size, page_num, by, order});
  },
};

export {company as default};
